import { Component, type ReactNode } from 'react';
import { isChunkLoadError, recoverCurrentChunk } from './chunk-recovery';

export class PageErrorBoundary extends Component<{ children: ReactNode }, { error: unknown }> {
  state: { error: unknown } = { error: null };
  static getDerivedStateFromError(error: unknown) { return { error }; }
  componentDidCatch(error: unknown) { recoverCurrentChunk(error); }
  render() {
    if (!this.state.error) return this.props.children;
    const chunk = isChunkLoadError(this.state.error);
    return <div role="alert" className="m-6 rounded-xl border border-border bg-card p-6">
      <h2 className="text-lg font-semibold">{chunk ? '页面资源暂时无法加载' : '页面加载遇到问题'}</h2>
      <p className="mt-2 text-sm text-muted-foreground">{chunk ? '应用可能已更新，或网络暂时中断。刷新后将重新加载当前页面。' : '请刷新重试；如果仍然失败，请保留报错信息。'}</p>
      <button className="mt-4 rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground" onClick={() => window.location.reload()}>刷新当前页面</button>
    </div>;
  }
}
